'use strict';

import { addEvent } from './addEvent/addEvent';
import { mainPageBaner } from './mainPageBaner/mainPageBaner';
// import { siemaInit } from './siema/siema';
import { marquee } from './marquee/marquee';

//import '@splidejs/splide/css';
import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', () => {
  window.mainPagebaner = new mainPageBaner(
    document.getElementsByClassName('main-page-baner')
      ? document.getElementsByClassName('main-page-baner')[0]
      : null
  );

  if (window.mainPagebaner) window.mainPagebaner.init();
  if (window.mainPagebaner) window.mainPagebaner.start();

  let categoryListSplide = new Splide('#splide1', {
    type: 'loop',
    perPage: 6,
    arrows: false,
    pagination: false,
    breakpoints: {
      640: {
        perPage: 2,
      },
    },
  });
  categoryListSplide.mount();

  let productListSplide = new Splide('#splide2', {
    type: 'loop',
    perPage: 6,
    arrows: false,
    pagination: false,
    breakpoints: {
      1200: {
        perPage: 4,
      },
      640: {
        perPage: 1,
      },
    },
  });
  productListSplide.mount();

  /*
  siemaInit({
    selector: '.main__category-list',
    auto: true,
    loop: true,
    breakpoints: {
      1500: 4,
      900: 3,
      400: 1,
    },
  });

  siemaInit({
    selector: '.main__produkty-list',
    auto: true,
    perPage: 8,
    autoTime: 2000,
    loop: true,
    breakpoints: {
      1500: 4,
      900: 3,
      400: 1,
    },
  });
  */

  marquee('.marquee', 10);
});

addEvent(window, 'load', () => {});

addEvent(window, 'resize', () => {});

addEvent(window, 'scroll', () => {});
